import React from "react"
import PropTypes from "prop-types"
import ScrollToPosition from '../utils/ScrollToPosition'

class BottomModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit"
    }
  }

  render() {
    return(
      <div
        style={{
          top: 0,
          left: 0,
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 11
        }}>
        <ScrollToPosition />
        <div className="bottomModal">
          {this.props.children}
        </div>
        <div style={{backgroundColor: 'rgba(255,255,255,.8)', zindex: 20, top: 0, left: 0, position: 'fixed', width: '100%', height: '100%'}} onClick={() => this.props.onClose()}>
        </div>
      </div>
    )
  }
}

export default BottomModal;
